import React, { FC } from "react";

// section componet
import { SectionTitle } from "./components/SectionTitle";
import { RecentlyLandAdded } from "./components/RecentlyLandAdded";
import { RecentOrder } from "./components/RecentOrder";
import { StockSummary } from "./components/StockSummary";
import { ReserveBunch } from "./components/ReserveBunch";
import { OverView } from "./components/OverView";

// navigate button
import { NavigateButton } from "./components/NavigateButton";

// custom hook
import { useFetchData } from "../../hooks/UseFetchData";

// api
import { DashboardAPI } from "../../../api/dashboard/dashboardAPI";
import { PageTitle } from "../../../_jutemplate/layout/core";
const dashboard = new DashboardAPI();

export const Hanay: FC = () => {
  const [
    dashboardSummaryFetch,
    dashboardSummaryFetchLoading,
    dashboardSummaryFetchError,
  ] = useFetchData(dashboard.getDashboardSummary);

  console.log(dashboardSummaryFetch);

  const {
    myTotalFarmers,
    aggregatorTotalFarmers,
    totalCustomers,
    totalCompletedOrders,
    totalRunningOrders,
    recentOrders,
    recentlyAddedLands,
  } = dashboardSummaryFetch?.data?.data || {};

  const breadcrumbs = [
    {
      title: "Dashboard",
      path: "/dashboard",
      isActive: true,
      isSeparator: false,
    },
 ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Hanay</PageTitle>
      <section
        className="p-7 rounded-4"
        style={{ backgroundColor: "#FFFFFF", border: "1px solid #EAECF0" }}
      >
        <SectionTitle>Overview</SectionTitle>
        <OverView
          data={{
            myTotalFarmers,
            aggregatorTotalFarmers,
            totalCustomers,
            totalCompletedOrders,
            totalRunningOrders,
          }}
          loading={dashboardSummaryFetchLoading}
          error={dashboardSummaryFetchError}
        />
      </section>
      

      <section className="mt-8">
        <div className="row gy-8">
          <div className="col-lg-8">
            <div className="p-7 rounded-4 h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: "#FFFFFF", border: "1px solid #EAECF0" }} >
              <div>
              <SectionTitle>Reserve Bunch List</SectionTitle>
              <ReserveBunch/>
              </div>
              <div className="mt-3">
                 <NavigateButton to={'/reserve-bunch/my-farmers'}>Explore</NavigateButton>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="p-7 rounded-4 h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: "#FFFFFF", border: "1px solid #EAECF0" }} >
              <div>
              <SectionTitle>Recently Land Added</SectionTitle>
              <RecentlyLandAdded
                data={recentlyAddedLands}
                loading={dashboardSummaryFetchLoading}
                error={dashboardSummaryFetchError}
              />
              </div>
              <div className="d-flex justify-content-end">
                 <NavigateButton to={'/supplier/my-farmers'}>Explore</NavigateButton>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-8">
        <div className="row gy-8">
          <div className="col-lg-8">
            <div className="p-7 rounded-4 h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: "#FFFFFF", border: "1px solid #EAECF0" }} >
              <div>
              <SectionTitle>Order Summary (This Monthy)</SectionTitle>
              <StockSummary/>
              </div>
              <div className="mt-3">
                 <NavigateButton to={'/customer/order'}>Explore</NavigateButton>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="p-7 rounded-4 h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: "#FFFFFF", border: "1px solid #EAECF0" }} >
              <div>
              <SectionTitle>Recent Order</SectionTitle>
              <RecentOrder
                data={recentOrders}
                loading={dashboardSummaryFetchLoading}
                error={dashboardSummaryFetchError}
              />
              </div>
              <div className="d-flex justify-content-end">
                 <NavigateButton to={'/customer/order'}>Explore</NavigateButton>
              </div>
            </div>
          </div>
        </div>
      </section>
     </>
  );
};
